export const SET_NEW_FAVORITES = 'SET_NEW_FAVORITES';
export const SET_NEW_RETWEETS = 'SET_NEW_RETWEETS';
export const SET_LIKES_RETWEETS_DATES = 'SET_LIKES_RETWEETS_DATES';


export const setNewFavorites = (value) => ({
  type: SET_NEW_FAVORITES,
  value
});
export const setNewRetweets = (value) => ({
  type: SET_NEW_RETWEETS,
  value
});
export const setLikesRetweetsDates = (value) => ({
  type: SET_LIKES_RETWEETS_DATES,
  value
});


export const SET_NEW_FOLLOWERS = 'SET_NEW_FOLLOWERS';
export const SET_NEW_FRIENDS = 'SET_NEW_FRIENDS';
export const SET_NEW_TWEETS = 'SET_NEW_TWEETS';
export const SET_TOTAL_FOLLOWERS = 'SET_TOTAL_FOLLOWERS';
export const SET_TOTAL_FRIENDS = 'SET_TOTAL_FRIENDS';
export const SET_TOTAL_TWEETS = 'SET_TOTAL_TWEETS';
export const SET_FOLLOWERS_FRIENDS_TWEETS_DATES = 'SET_FOLLOWERS_FRIENDS_TWEETS_DATES';

export const setNewFollowers = (value) => ({
  type: SET_NEW_FOLLOWERS,
  value
});
export const setNewFriends = (value) => ({
  type: SET_NEW_FRIENDS,
  value
});
export const setNewTweets = (value) => ({
  type: SET_NEW_TWEETS,
  value
});
export const setTotalFollowers = (value) => ({
  type: SET_TOTAL_FOLLOWERS,
  value
});
export const setTotalFriends = (value) => ({
  type: SET_TOTAL_FRIENDS,
  value
});
export const setTotalTweets = (value) => ({
  type: SET_TOTAL_TWEETS,
  value
});
export const setFollowersFriendsTweetsDates = (value) => ({
  type: SET_FOLLOWERS_FRIENDS_TWEETS_DATES,
  value
});


export const SET_REPLIES_MENTIONS_SUMS = 'SET_REPLIES_MENTIONS_SUMS';
export const SET_REPLIES_MENTIONS_DATES = 'SET_REPLIES_MENTIONS_DATES';

export const setRepliesMentionsSums = (value) => ({
  type: SET_REPLIES_MENTIONS_SUMS,
  value
});
export const setRepliesMentionsDates = (value) => ({
  type: SET_REPLIES_MENTIONS_DATES,
  value
});







// WEBPACK FOOTER //
// ./src/actions/engage-actions.js